var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJdbc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "78px",
    height: "78px",
    viewBox: "0 0 78 78",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "selectJDBC") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Catalogue-des-Sources",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "selectJDBC"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 78,
    height: 78,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "database-(3)",
    transform: "translate(24.000000, 12.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,0 C6.7125,0 0,3.18222222 0,7.11111111 C0,11.04 6.7125,14.2222222 15,14.2222222 C23.2875,14.2222222 30,11.04 30,7.11111111 C30,3.18222222 23.2875,0 15,0 M0,10.6666667 L0,16 C0,19.9288889 6.7125,23.1111111 15,23.1111111 C23.2875,23.1111111 30,19.9288889 30,16 L30,10.6666667 C30,14.5955556 23.2875,17.7777778 15,17.7777778 C6.7125,17.7777778 0,14.5955556 0,10.6666667 M0,19.5555556 L0,24.8888889 C0,28.8177778 6.7125,32 15,32 C23.2875,32 30,28.8177778 30,24.8888889 L30,19.5555556 C30,23.4844444 23.2875,26.6666667 15,26.6666667 C6.7125,26.6666667 0,23.4844444 0,19.5555556 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJdbc);
export default __webpack_public_path__ + "static/media/jdbc.6c7e8105222f31064c3857f0f4907155.svg";
export { ForwardRef as ReactComponent };